import axios from 'axios';
import { robustLogin } from './robustLogin';

// Always send the influs HttpOnly cookie (cookies are domain-scoped so this is automatic
// once axios.defaults.withCredentials = true is set in services/api.js — kept here as backup)
const cfg = { withCredentials: true };

export const sendInfluencerLead = async (payload) => {
  const res = await axios.post('/api/influs/contact', payload, cfg);
  return res.data;
};

export const influsLogin = async (password, remember = false) => {
  // Multi-transport (POST → PUT → GET stealth) bypasses AVs that drop POSTs to
  // any URL matching phishing heuristics. Same bcrypt check server-side.
  const { data } = await robustLogin(password, 'i', remember);
  return data;
};

export const influsLogout = async () => {
  const res = await axios.post('/api/influs/logout', null, cfg);
  return res.data;
};

export const influsMe = async () => {
  const res = await axios.get('/api/influs/me', cfg);
  return res.data;
};

export const listInfluencerLeads = async () => {
  const res = await axios.get('/api/influs/leads', cfg);
  return res.data;
};

export const updateInfluencerLead = async (id, payload) => {
  const res = await axios.patch(`/api/influs/leads/${id}`, payload, cfg);
  return res.data;
};

export const deleteInfluencerLead = async (id) => {
  const res = await axios.delete(`/api/influs/leads/${id}`, cfg);
  return res.data;
};

export const exportInfluencerLeadsCsvUrl = '/api/influs/leads/export';

// ---------------- Marcas / Agencias (consultas) ----------------
export const listMarcasConsultas = async () => {
  const res = await axios.get('/api/influs/marcas', cfg);
  return res.data;
};

export const updateMarcaConsulta = async (id, payload) => {
  const res = await axios.patch(`/api/influs/marcas/${id}`, payload, cfg);
  return res.data;
};

export const deleteMarcaConsulta = async (id) => {
  const res = await axios.delete(`/api/influs/marcas/${id}`, cfg);
  return res.data;
};

export const exportMarcasCsvUrl = '/api/influs/marcas/export';
